import type { FaireProductEntity } from "../../entity_types/product";

export const p_vndrc5e385: FaireProductEntity = {
  token: "p_vndrc5e385",
  type: "product",
  name: "18k GF Colorful Festive Jewelry Set With 18",
  brandToken: "b_9zxdpx73wa",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5d182d48569c7470832023e21ba3165d6fcdd452bd0c7ec5b21e141386ee4ce1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/24f862cfdeb9c58d4bcc6daaf6e041e1263844d7c637a2acc362ba14cd8b6c18.jpeg",
    "https://cdn.faire.com/fastly/d9ee7d934a27cc373ad3e0e6a462a03d14a3afe2627241a07d7e039becbff1c5.jpeg",
    "https://cdn.faire.com/fastly/c81d3160590f1d01250bb1c0a8ab933b7bfb233bbf9bcf4be1f2803f3110e7a2.jpeg",
  ],
  priceDollars: 24.81,
  description:
    '18k GF Colorful Festive Jewelry Set Size available: 18” Necklace Bracelet 7" + 1.5" extender \n * Nickel Free \n * Hypoallergenic \n * Water friendly \n * Made in Brazil \nOur online store was developed to help you find the most unique styles of modern designs, always looking for elegance and market trends. Here you will find ways to better make your jewelry through quality, seeking harmony, exclusivity and impeccable finish.',
  tags: [],
  msrpDollars: 49.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:45.035Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
